module.exports = __webpack_public_path__ + "static/media/recorrido25k.0408c9c5.webp";